import { Link } from "react-router-dom";

const Location = () => {
  return (
    <>
      <div
        className="inner-banner banner"
        style={{ background: 'url("images/product-banner.jpg")' }}
      >
        <div className="container">
          <div className="inner-banner-txt">
            <h1 className="banner-banner-heading text-white fs-45">
              Our Store
            </h1>
            <nav aria-label="breadcrumb" className="breadcrumb-nav">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Location{" "}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <section className="main-section location-section border-top border-bottom p-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-3 col-xs-12 border-right">
              <div className="location-widget justify-content-center d-flex align-items-center h-100 pt-0">
                <div className="site-logo footer-logo">
                  <h2>Location</h2>
                </div>
              </div>
            </div>
            {/* col */}
            <div className="col-lg-4 col-sm-4 col-xs-12 border-right">
              <div className="location-widget">
                <div className="location-header">
                  <h5 className="tcolor">MUMBAI</h5>
                  <a href="#">Directions</a>
                </div>
                <p className="wow fadeInUp">
                  31 Perry Cross Road, Near Otter's Club, Bandra West, Mumbai,
                  Maharashtra, 400050
                </p>
                <p className="wow fadeInUp">
                  <a href="tel:+91 9920 206 723">+91 9920 206 723</a>
                </p>
                <p className="wow fadeInUp">
                  Mon to Fri - 10 am to 4 pm <br />
                  <a href="emailto:contact.mumbai@fashion-hub.com">
                    contact.mumbai@fashion-hub.com
                  </a>
                </p>
              </div>
              <div className="location-widget pb-5">
                <div className="location-header">
                  <h5 className="tcolor">AHMEDABAD</h5>
                  <a href="#">Directions</a>
                </div>
                <p className="wow fadeInUp">
                  Near Kotak House, Behind Kensville Golf Academy, Bodakdev,
                  Ahmedabad, Gujarat, 380059
                </p>
                <p className="wow fadeInUp">
                  <a href="tel:+91 9920 206 723">+91 9920 206 723</a>
                </p>
                <p className="wow fadeInUp">
                  Mon to Fri - 10 am to 4 pm <br />
                  <a href="emailto:contact.mumbai@fashion-hub.com">
                    contact.mumbai@fashion-hub.com
                  </a>
                </p>
              </div>
            </div>
            {/* col */}
            <div className="col-lg-4 col-sm-4 col-xs-12">
              <div className="location-widget">
                <div className="location-header">
                  <h5 className="tcolor">HYDERABAD</h5>
                  <a href="#">Directions</a>
                </div>
                <p className="wow fadeInUp">
                  Lane next to HDFC Bank, Road Number 14, Venkat Nagar, Banjara
                  Hills, Hyderabad, Telangana, 500034
                </p>
                <p className="wow fadeInUp">
                  <a href="tel:+91 9920 206 723">+91 9920 206 723</a>
                </p>
                <p className="wow fadeInUp">
                  Mon to Fri - 10 am to 4 pm <br />
                  <a href="emailto:contact.mumbai@fashion-hub.com">
                    contact.mumbai@fashion-hub.com
                  </a>
                </p>
              </div>
              <div className="location-widget pb-5">
                <div className="location-header">
                  <h5 className="tcolor">JOBS</h5>
                </div>
                <p className="wow fadeInUp">
                  Visit
                  <a href="emailto:Careers@fashion-hub">Careers@fashion-hub</a>
                </p>
                <p className="wow fadeInUp">
                  or write in to us at
                  <a href="emailto:jobs@fashion-hub.com">
                    jobs@fashion-hub.com
                  </a>
                </p>
              </div>
            </div>
            {/* col */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Location;
